import get from 'lodash/get';
import * as htmlSitemapIndex from '../../action_creators/html_sitemap/html_sitemap_index_action_creators';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';
import SitemapIndexModel from '../../../models/html_sitemap/html_sitemap_index';
import log from '../../../services/logger_service';

export default function fetchSearchAction(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(htmlSitemapIndex.htmlSitemapIndexLoading({}, store));
    return SitemapIndexModel.fetch(params, store)
      .then(function handleSearchModelData(htmlSitemapIndexData) {
        dispatch(
          htmlSitemapIndex.htmlSitemapIndexLoaded(
            htmlSitemapIndexData.data,
            store
          )
        );
      })
      .catch(function handleSearchError(err) {
        const status = get(err, 'response.status') || 500;
        if (status === 404) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        } else {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
          log.error(
            err,
            `Error in htmlSitemapIndex actions, message: ${err.message}`
          );
        }
        return dispatch(
          htmlSitemapIndex.htmlSitemapIndexError(err.data, store)
        );
      });
  };
}
